import _ from "lodash";

import theme from "theme";
import { colors } from "theme/palette";
import { format, parseJSON } from "utils/datetime";

import Stack from "components/Stack";
import Tag from "components/Tag";
import Text from "components/Text";

import { MemoSignatureStatus } from "entities/Memo/components/Sections/MemoESignatureDrawer/constants";

const MemoESignatureTrackingProcessTag = ({
  status,
  signedAt,
  isCompleted,
}: {
  status: MemoSignatureStatus;
  signedAt?: string;
  isCompleted?: boolean;
}) => (
  <Stack direction="row" alignItems="center" marginTop={1} gap={1.25}>
    {status === MemoSignatureStatus.APPLIED && (
      <>
        {!_.isNil(isCompleted) ? (
          <Tag
            label={isCompleted ? "signed" : "signed by you"}
            variant="teal40"
            sx={{
              padding: theme.spacing(0.25, 1),
              borderRadius: "2px",
            }}
          />
        ) : (
          <Tag
            label="signature collected"
            variant="teal40"
            sx={{
              padding: theme.spacing(0.25, 1),
              borderRadius: "2px",
            }}
          />
        )}
        {_.isNil(isCompleted) && !_.isNil(signedAt) && (
          <Text variant="text4" color={colors.gray60}>
            Signed on {format(parseJSON(signedAt), "MMM dd, yyyy")}
          </Text>
        )}
      </>
    )}
    {status === MemoSignatureStatus.REJECTED && (
      <>
        <Tag
          label="signature rejected"
          variant="red100"
          sx={{
            padding: theme.spacing(0.25, 1),
            borderRadius: "2px",
          }}
        />
        {_.isNil(isCompleted) && (
          <Text variant="text4" color={colors.red100}>
            The signature has been rejected resulting in termination of the
            e-signature process
          </Text>
        )}
      </>
    )}
    {status === MemoSignatureStatus.PENDING && (
      <Tag
        label="signature pending"
        variant="yellow100"
        sx={{
          padding: theme.spacing(0.25, 1),
          borderRadius: "2px",
        }}
      />
    )}
    {status === MemoSignatureStatus.DRAFT && (
      <>
        <Tag
          label="signing on hold"
          variant="gray60"
          sx={{
            padding: theme.spacing(0.25, 1),
            borderRadius: "2px",
          }}
        />
        <Text variant="text4" color={colors.gray60}>
          Signatories ahead in the signing order must sign first.
        </Text>
      </>
    )}
    {status === MemoSignatureStatus.TERMINATED && (
      <>
        <Tag
          label="signature terminated"
          variant="gray60"
          sx={{
            padding: theme.spacing(0.25, 1),
            borderRadius: "2px",
          }}
        />
        <Text variant="text4" color={colors.gray60}>
          The e-signature process has been terminated.
        </Text>
      </>
    )}
  </Stack>
);

export default MemoESignatureTrackingProcessTag;
